import React from 'react';
import { Star, Quote, ArrowRight } from 'lucide-react';

export const GOOGLE_REVIEWS_URL =
  'https://www.google.com/maps/place/Orosz+Coaching/@48.1081874,20.7947038,17z/data=!4m17!1m8!3m7!1s0x47409fa8a70d1285:0xc33e2cfae977d768!2sOrosz+Coaching!8m2!3d48.1081838!4d20.7972787!10e1!16s%2Fg%2F11zglvmh37!3m7!1s0x47409fa8a70d1285:0xc33e2cfae977d768!8m2!3d48.1081838!4d20.7972787!9m1!1b1!16s%2Fg%2F11zglvmh37';

const defaultReviews = [
  {
    name: 'Miklós',
    source: 'Google-értékelés',
    content:
      'Szakmailag nagyon felkészült, és ami nekem legalább ennyire fontos, az a hozzáállása, a folyamatos támogatása és a hasznos, személyre szabott tanácsai. […] Az elmúlt körülbelül két és fél hónap alatt 11 kilót sikerült leadnom, és sokkal fittebbnek is érzem magam.',
  },
  {
    name: 'Patricia',
    source: 'Google-értékelés',
    content:
      'Kedves, türelmes, értelmesen magyaráz. […] Én az online coachingot választottam, és nem bántam meg. Egyszerű a felület használata, és külön pont, hogy a fejlődésemet is láthatom.',
  },
];

const ReviewsSection = ({ title = 'Amit az ügyfeleim mondanak', reviews = defaultReviews }) => {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 md:py-24 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mb-12">
          <div className="inline-block mb-4 px-4 py-2 bg-yellow-600/20 border border-yellow-600/30 rounded-full">
            <span className="text-yellow-400 font-semibold text-sm tracking-wider">ÜGYFÉLVÉLEMÉNYEK</span>
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-white leading-tight"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            {title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div
              key={review.name}
              data-testid={`review-card-${index}`}
              className="bg-gray-800/60 border border-gray-700 rounded-xl p-6 md:p-8 backdrop-blur-sm hover:bg-gray-800/80 hover:border-yellow-600/40 transition-all duration-300"
            >
              <Quote className="text-yellow-600 mb-4" size={28} />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="text-yellow-500 fill-yellow-500" size={15} />
                ))}
              </div>
              <p className="text-gray-300 leading-relaxed mb-5 break-words">„{review.content}”</p>
              <div className="text-sm">
                <span className="font-bold text-white">{review.name}</span>
                <span className="text-gray-500"> · {review.source}</span>
              </div>
            </div>
          ))}
        </div>

        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="all-google-reviews-link"
          className="group inline-flex items-center gap-2 mt-8 text-sm font-bold text-yellow-400 hover:text-yellow-300 transition-colors"
        >
          Összes vélemény a Google-on
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </section>
  );
};

export default ReviewsSection;
